import React from "react";
import "./themeToggleV2.css";

/**
 * Dev-only floating control for the v2 preview: light/dark theme. Rendered at
 * the layout root so it is NOT inside any backdrop-filter ancestor (which
 * would break its position:fixed).
 *
 * THE BACKGROUND BUTTON IS GONE (2026-10-07). It switched `data-bg` between
 * "image" and "gradient" — but the public pages no longer carry a background
 * image at all (the wood photo belongs to the Home About banner now), so both
 * states resolved to the same thing. A control that reports a state it does
 * not change is worse than no control.
 *
 * For prod, this control is removed; the underlying token system (`data-theme`
 * on .bdrv2-root) stays as the drop-in theming mechanism.
 */
const ThemeToggleV2 = ({ theme, onThemeToggle }) => {
  return (
    <div className="bdrv2-toggle" role="group" aria-label="Preview appearance controls">
      <button
        type="button"
        className="bdrv2-toggle-btn"
        onClick={onThemeToggle}
        aria-pressed={theme === "light"}
        title="Toggle light / dark theme"
      >
        {theme === "dark" ? "☀ Light" : "☾ Dark"}
      </button>
    </div>
  );
};

export default ThemeToggleV2;
